<template>
    <div>
        <rkm-form
            v-if="form"
            ref="RkmForm"
        >
            <BoxHistorico :data="historicoData" v-if="form"/>
        </rkm-form>
    </div>
</template>

<script>
// Components.
import BoxHistorico from './Index'

// Vuex.
import {mapActions} from 'vuex'

export default {
    components: {
        BoxHistorico
    },
    computed: {
        historicoData() {
            return {
                form: this.form,
            }
        },
    },
    data: () => ({
        form: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()
            this.form = this.data
            this.unsetLoading()
        },
    },
    mounted() {
        this.load()
    },
    props: {
        data: {type: [Object, Array], required: true},
    },
}
</script>